import { render, staticRenderFns } from "./AddImage.vue?vue&type=template&id=5b046484&"
import script from "./AddImage.vue?vue&type=script&lang=js&"
export * from "./AddImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports